import * as React from "react";
import type { Agent } from "@/data/types";

interface Props {
  agent: Agent;
}

export const PresentationFooter: React.FC<Props> = ({ agent }) => {
  const year = new Date().getFullYear();
  return (
    <footer
      className="w-full border-t border-charcoal/10 bg-ivory py-10"
      data-testid="presentation-footer"
    >
      <div className="mx-auto flex w-full max-w-5xl flex-col items-start justify-between gap-4 px-6 md:flex-row md:items-center md:px-10">
        <div>
          <p className="font-serif text-base text-charcoal">{agent.name}</p>
          {agent.title && (
            <p className="mt-0.5 text-sm text-charcoal-soft">{agent.title}</p>
          )}
          {agent.team && (
            <p className="mt-0.5 text-sm text-charcoal-muted">{agent.team}</p>
          )}
          {agent.officeAddress && (
            <p className="mt-0.5 text-sm text-charcoal-muted">{agent.officeAddress}</p>
          )}
          {agent.brokerage && (
            <p className="mt-1 text-xs uppercase tracking-[0.16em] text-charcoal-muted">
              {agent.brokerage}
            </p>
          )}
        </div>
        <div className="text-left md:text-right">
          <p className="text-[0.7rem] uppercase tracking-[0.22em] text-charcoal-muted/80">
            Presentation powered by PitchAI
          </p>
          <p className="mt-1 text-[0.7rem] text-charcoal-muted/60">
            Private · Prepared {year}
          </p>
        </div>
      </div>
    </footer>
  );
};
